import { c as _c } from "react/compiler-runtime";
import { SupportedLocales, extractLocaleInformation, getSupportedLocaleFromAnyLocale } from '@commutifi/constants/Locale';
import momentDurationFormatSetup from 'moment-duration-format';
import moment, { updateLocale as setMomentLocale } from 'moment-timezone';
import React from 'react';
import { getMomentLocale } from 'constants/settings';
import { useIntl } from 'locales/index';
import { LocalesType } from '@commutifi-fe/constants';

// I know it's ugly but don't want to loose my time with something not important
momentDurationFormatSetup(moment as any);

/**
 * Only reason we extract this as a component is to have access to useIntl
 * in the DOM three ancestry
 */
export function MomentLocalization(t0) {
  const $ = _c(158);
  const {
    locale
  } = t0;
  const intl = useIntl();
  moment.updateLocale("en-US", {
    week: {
      dow: 1
    }
  });
  let t1;
  if ($[0] !== locale) {
    const supportedLocale = getSupportedLocaleFromAnyLocale(locale);
    t1 = supportedLocale === SupportedLocales.enUS || supportedLocale === SupportedLocales.enCA || supportedLocale === SupportedLocales.frCA ? 1 : extractLocaleInformation(supportedLocale).weekInfo?.firstDay ?? 1;
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      dow: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== intl) {
    t3 = intl.formatMessage({
      id: "duration.labels.one.milliseconds"
    });
    $[4] = intl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== intl) {
    t4 = intl.formatMessage({
      id: "duration.labels.two.milliseconds"
    });
    $[6] = intl;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== intl) {
    t5 = intl.formatMessage({
      id: "duration.labels.threeOrMore.milliseconds"
    });
    $[8] = intl;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== intl) {
    t6 = intl.formatMessage({
      id: "duration.labels.one.seconds"
    });
    $[10] = intl;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== intl) {
    t7 = intl.formatMessage({
      id: "duration.labels.two.seconds"
    });
    $[12] = intl;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== intl) {
    t8 = intl.formatMessage({
      id: "duration.labels.threeOrMore.seconds"
    });
    $[14] = intl;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== intl) {
    t9 = intl.formatMessage({
      id: "duration.labels.one.minutes"
    });
    $[16] = intl;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== intl) {
    t10 = intl.formatMessage({
      id: "duration.labels.two.minutes"
    });
    $[18] = intl;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== intl) {
    t11 = intl.formatMessage({
      id: "duration.labels.threeOrMore.minutes"
    });
    $[20] = intl;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== intl) {
    t12 = intl.formatMessage({
      id: "duration.labels.one.hours"
    });
    $[22] = intl;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== intl) {
    t13 = intl.formatMessage({
      id: "duration.labels.two.hours"
    });
    $[24] = intl;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== intl) {
    t14 = intl.formatMessage({
      id: "duration.labels.threeOrMore.hours"
    });
    $[26] = intl;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== intl) {
    t15 = intl.formatMessage({
      id: "duration.labels.one.days"
    });
    $[28] = intl;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== intl) {
    t16 = intl.formatMessage({
      id: "duration.labels.two.days"
    });
    $[30] = intl;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== intl) {
    t17 = intl.formatMessage({
      id: "duration.labels.threeOrMore.days"
    });
    $[32] = intl;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== intl) {
    t18 = intl.formatMessage({
      id: "duration.labels.one.weeks"
    });
    $[34] = intl;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== intl) {
    t19 = intl.formatMessage({
      id: "duration.labels.two.weeks"
    });
    $[36] = intl;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== intl) {
    t20 = intl.formatMessage({
      id: "duration.labels.threeOrMore.weeks"
    });
    $[38] = intl;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== intl) {
    t21 = intl.formatMessage({
      id: "duration.labels.one.months"
    });
    $[40] = intl;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== intl) {
    t22 = intl.formatMessage({
      id: "duration.labels.two.months"
    });
    $[42] = intl;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== intl) {
    t23 = intl.formatMessage({
      id: "duration.labels.threeOrMore.months"
    });
    $[44] = intl;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== intl) {
    t24 = intl.formatMessage({
      id: "duration.labels.one.years"
    });
    $[46] = intl;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== intl) {
    t25 = intl.formatMessage({
      id: "duration.labels.two.years"
    });
    $[48] = intl;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== intl) {
    t26 = intl.formatMessage({
      id: "duration.labels.threeOrMore.years"
    });
    $[50] = intl;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t10 || $[53] !== t11 || $[54] !== t12 || $[55] !== t13 || $[56] !== t14 || $[57] !== t15 || $[58] !== t16 || $[59] !== t17 || $[60] !== t18 || $[61] !== t19 || $[62] !== t20 || $[63] !== t21 || $[64] !== t22 || $[65] !== t23 || $[66] !== t24 || $[67] !== t25 || $[68] !== t26 || $[69] !== t3 || $[70] !== t4 || $[71] !== t5 || $[72] !== t6 || $[73] !== t7 || $[74] !== t8 || $[75] !== t9) {
    t27 = {
      S: t3,
      SS: t4,
      SSS: t5,
      s: t6,
      ss: t7,
      sss: t8,
      m: t9,
      mm: t10,
      mmm: t11,
      h: t12,
      hh: t13,
      hhh: t14,
      d: t15,
      dd: t16,
      ddd: t17,
      w: t18,
      ww: t19,
      www: t20,
      M: t21,
      MM: t22,
      MMM: t23,
      y: t24,
      yy: t25,
      yyy: t26
    };
    $[52] = t10;
    $[53] = t11;
    $[54] = t12;
    $[55] = t13;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
    $[59] = t17;
    $[60] = t18;
    $[61] = t19;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
    $[66] = t24;
    $[67] = t25;
    $[68] = t26;
    $[69] = t3;
    $[70] = t4;
    $[71] = t5;
    $[72] = t6;
    $[73] = t7;
    $[74] = t8;
    $[75] = t9;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  let t28;
  if ($[77] !== intl) {
    t28 = intl.formatMessage({
      id: "duration.labels.one.milliseconds.short"
    });
    $[77] = intl;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== intl) {
    t29 = intl.formatMessage({
      id: "duration.labels.two.milliseconds.short"
    });
    $[79] = intl;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  let t30;
  if ($[81] !== intl) {
    t30 = intl.formatMessage({
      id: "duration.labels.threeOrMore.milliseconds.short"
    });
    $[81] = intl;
    $[82] = t30;
  } else {
    t30 = $[82];
  }
  let t31;
  if ($[83] !== intl) {
    t31 = intl.formatMessage({
      id: "duration.labels.one.seconds.short"
    });
    $[83] = intl;
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  let t32;
  if ($[85] !== intl) {
    t32 = intl.formatMessage({
      id: "duration.labels.two.seconds.short"
    });
    $[85] = intl;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] !== intl) {
    t33 = intl.formatMessage({
      id: "duration.labels.threeOrMore.seconds.short"
    });
    $[87] = intl;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  let t34;
  if ($[89] !== intl) {
    t34 = intl.formatMessage({
      id: "duration.labels.one.minutes.short"
    });
    $[89] = intl;
    $[90] = t34;
  } else {
    t34 = $[90];
  }
  let t35;
  if ($[91] !== intl) {
    t35 = intl.formatMessage({
      id: "duration.labels.two.minutes.short"
    });
    $[91] = intl;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  let t36;
  if ($[93] !== intl) {
    t36 = intl.formatMessage({
      id: "duration.labels.threeOrMore.minutes.short"
    });
    $[93] = intl;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== intl) {
    t37 = intl.formatMessage({
      id: "duration.labels.one.hours.short"
    });
    $[95] = intl;
    $[96] = t37;
  } else {
    t37 = $[96];
  }
  let t38;
  if ($[97] !== intl) {
    t38 = intl.formatMessage({
      id: "duration.labels.two.hours.short"
    });
    $[97] = intl;
    $[98] = t38;
  } else {
    t38 = $[98];
  }
  let t39;
  if ($[99] !== intl) {
    t39 = intl.formatMessage({
      id: "duration.labels.threeOrMore.hours.short"
    });
    $[99] = intl;
    $[100] = t39;
  } else {
    t39 = $[100];
  }
  let t40;
  if ($[101] !== intl) {
    t40 = intl.formatMessage({
      id: "duration.labels.one.days.short"
    });
    $[101] = intl;
    $[102] = t40;
  } else {
    t40 = $[102];
  }
  let t41;
  if ($[103] !== intl) {
    t41 = intl.formatMessage({
      id: "duration.labels.two.days.short"
    });
    $[103] = intl;
    $[104] = t41;
  } else {
    t41 = $[104];
  }
  let t42;
  if ($[105] !== intl) {
    t42 = intl.formatMessage({
      id: "duration.labels.threeOrMore.days.short"
    });
    $[105] = intl;
    $[106] = t42;
  } else {
    t42 = $[106];
  }
  let t43;
  if ($[107] !== intl) {
    t43 = intl.formatMessage({
      id: "duration.labels.one.weeks.short"
    });
    $[107] = intl;
    $[108] = t43;
  } else {
    t43 = $[108];
  }
  let t44;
  if ($[109] !== intl) {
    t44 = intl.formatMessage({
      id: "duration.labels.two.weeks.short"
    });
    $[109] = intl;
    $[110] = t44;
  } else {
    t44 = $[110];
  }
  let t45;
  if ($[111] !== intl) {
    t45 = intl.formatMessage({
      id: "duration.labels.threeOrMore.weeks.short"
    });
    $[111] = intl;
    $[112] = t45;
  } else {
    t45 = $[112];
  }
  let t46;
  if ($[113] !== intl) {
    t46 = intl.formatMessage({
      id: "duration.labels.one.months.short"
    });
    $[113] = intl;
    $[114] = t46;
  } else {
    t46 = $[114];
  }
  let t47;
  if ($[115] !== intl) {
    t47 = intl.formatMessage({
      id: "duration.labels.two.months.short"
    });
    $[115] = intl;
    $[116] = t47;
  } else {
    t47 = $[116];
  }
  let t48;
  if ($[117] !== intl) {
    t48 = intl.formatMessage({
      id: "duration.labels.threeOrMore.months.short"
    });
    $[117] = intl;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  let t49;
  if ($[119] !== intl) {
    t49 = intl.formatMessage({
      id: "duration.labels.one.years.short"
    });
    $[119] = intl;
    $[120] = t49;
  } else {
    t49 = $[120];
  }
  let t50;
  if ($[121] !== intl) {
    t50 = intl.formatMessage({
      id: "duration.labels.two.years.short"
    });
    $[121] = intl;
    $[122] = t50;
  } else {
    t50 = $[122];
  }
  let t51;
  if ($[123] !== intl) {
    t51 = intl.formatMessage({
      id: "duration.labels.threeOrMore.years.short"
    });
    $[123] = intl;
    $[124] = t51;
  } else {
    t51 = $[124];
  }
  let t52;
  if ($[125] !== t28 || $[126] !== t29 || $[127] !== t30 || $[128] !== t31 || $[129] !== t32 || $[130] !== t33 || $[131] !== t34 || $[132] !== t35 || $[133] !== t36 || $[134] !== t37 || $[135] !== t38 || $[136] !== t39 || $[137] !== t40 || $[138] !== t41 || $[139] !== t42 || $[140] !== t43 || $[141] !== t44 || $[142] !== t45 || $[143] !== t46 || $[144] !== t47 || $[145] !== t48 || $[146] !== t49 || $[147] !== t50 || $[148] !== t51) {
    t52 = {
      S: t28,
      SS: t29,
      SSS: t30,
      s: t31,
      ss: t32,
      sss: t33,
      m: t34,
      mm: t35,
      mmm: t36,
      h: t37,
      hh: t38,
      hhh: t39,
      d: t40,
      dd: t41,
      ddd: t42,
      w: t43,
      ww: t44,
      www: t45,
      M: t46,
      MM: t47,
      MMM: t48,
      y: t49,
      yy: t50,
      yyy: t51
    };
    $[125] = t28;
    $[126] = t29;
    $[127] = t30;
    $[128] = t31;
    $[129] = t32;
    $[130] = t33;
    $[131] = t34;
    $[132] = t35;
    $[133] = t36;
    $[134] = t37;
    $[135] = t38;
    $[136] = t39;
    $[137] = t40;
    $[138] = t41;
    $[139] = t42;
    $[140] = t43;
    $[141] = t44;
    $[142] = t45;
    $[143] = t46;
    $[144] = t47;
    $[145] = t48;
    $[146] = t49;
    $[147] = t50;
    $[148] = t51;
    $[149] = t52;
  } else {
    t52 = $[149];
  }
  let t53;
  if ($[150] !== t2 || $[151] !== t27 || $[152] !== t52) {
    t53 = {
      week: t2,
      durationLabelsStandard: t27,
      durationLabelsShort: t52
    };
    $[150] = t2;
    $[151] = t27;
    $[152] = t52;
    $[153] = t53;
  } else {
    t53 = $[153];
  }
  const momentConfig = t53;
  let t54;
  let t55;
  if ($[154] !== locale || $[155] !== momentConfig) {
    t54 = () => {
      setMomentLocale(getMomentLocale(getSupportedLocaleFromAnyLocale(locale)), momentConfig);
    };
    t55 = [momentConfig, locale];
    $[154] = locale;
    $[155] = momentConfig;
    $[156] = t54;
    $[157] = t55;
  } else {
    t54 = $[156];
    t55 = $[157];
  }
  React.useEffect(t54, t55);
  return null;
}